// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1LGDH","rootSuccess":"CompleteLink_rootSuccess__3Jc9a","rootFailure":"CompleteLink_rootFailure__1kljE","isDisabled":"CompleteLink_isDisabled__10ACb"};